export default {
  DOBOKU: 10,
  SHISETSU_DENKI: 20,
  KOUKASHITA: 30,
}
